import { visit } from '../libs/Visitor'
import { DataResponse, MessageResponse, DataMessageResponse } from '../types/index'
import { IAM } from '../types/iam'

export type ProfileResponse = DataResponse<IAM.UserAggregate>
export type LoginResponse = DataMessageResponse<{
  access_token: string
  token_type: string
  expires_in: number
}>

export const auth = {
  sendResetPasswordEmail(email: string) {
    return visit<MessageResponse>({
      method: 'POST',
      url: 'request_reset_password',
      data: { email }
    })
  },

  resendVerifyEmail(email: string) {
    return visit<MessageResponse>({
      method: 'POST',
      url: 'resend_email',
      data: { email }
    })
  },

  resetPassword(data: { email: string; password: string; code: string }) {
    return visit<MessageResponse>({
      method: 'POST',
      url: 'reset_password',
      data
    })
  },

  register(data: { name: string; email: string; password: string }) {
    return visit<LoginResponse>({
      method: 'POST',
      url: 'users',
      data
    })
  },

  login(email: string, password: string) {
    return visit<LoginResponse>({
      method: 'POST',
      url: 'login',
      data: { email, password }
    })
  },

  logout() {
    return visit<MessageResponse>({
      method: 'POST',
      url: 'logout'
    })
  },

  refresh() {
    return visit<MessageResponse>({
      method: 'POST',
      url: 'token_refresh'
    })
  },

  me(token?: string) {
    const headers: {
      [k: string]: string
    } = {
      'Cache-Control': 'no-store'
    }
    if (token) {
      headers['Authorization'] = 'Bearer ' + token
    }
    return visit<ProfileResponse>({
      method: 'GET',
      url: 'me',
      headers
    })
  },

  beamAuth() {
    return visit<MessageResponse>({
      method: 'GET',
      url: 'beams-auth'
    })
  },
}
